import { render, staticRenderFns } from "./outboxrightclick.vue?vue&type=template&id=9b9ab484&"
import script from "./outboxrightclick.vue?vue&type=script&lang=js&"
export * from "./outboxrightclick.vue?vue&type=script&lang=js&"
import style0 from "./outboxrightclick.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports